import { Property } from '../../model/Property';
import { PropertyRepository } from '../../repositories/Repository';

export class GetPropertiesUseCase {
  constructor(private propertyRepository: PropertyRepository) {}

  async execute(): Promise<Property[]> {
    return await this.propertyRepository.getProperties();
  }
}